/**
 * デバイス・OS・ブラウザと言語情報を取得する共通ユーティリティ
 */
export type DeviceInfo = {
  device: 'mobile' | 'tablet' | 'desktop';
  os: 'Windows' | 'macOS' | 'Android' | 'iOS' | 'Linux' | 'Other';
  browser: 'Edge' | 'Chrome' | 'Firefox' | 'Safari' | 'Other';
  language: string;
  locale: string;
};

export const getDeviceInfo = (): DeviceInfo => {
  const userAgent = navigator.userAgent;

  // OS判定
  const os: DeviceInfo['os'] =
    /windows nt/i.test(userAgent) ? 'Windows'
    : /mac os x/i.test(userAgent) ? 'macOS'
    : /android/i.test(userAgent) ? 'Android'
    : /iphone|ipad|ipod/i.test(userAgent) ? 'iOS'
    : /linux/i.test(userAgent) ? 'Linux'
    : 'Other';

  // デバイス種別判定
  const device: DeviceInfo['device'] =
    /iphone|ipad|ipod|android|mobile/i.test(userAgent)
      ? 'mobile'
      : /tablet/i.test(userAgent)
        ? 'tablet'
        : 'desktop';

  // ブラウザ判定
  let browser: DeviceInfo['browser'] = 'Other';
  const edgeMatch = userAgent.match(/Edg\/([\d.]+)/);
  const chromeMatch = userAgent.match(/Chrome\/([\d.]+)/);
  const firefoxMatch = userAgent.match(/Firefox\/([\d.]+)/);
  const safariMatch = !chromeMatch && userAgent.match(/Version\/([\d.]+).*Safari/);

  if (edgeMatch) {
    browser = 'Edge';
  } else if (chromeMatch) {
    browser = 'Chrome';
  } else if (firefoxMatch) {
    browser = 'Firefox';
  } else if (safariMatch) {
    browser = 'Safari';
  }

  const locale = navigator.language || (navigator as never)['userLanguage'] || '';
  const language = locale.split('-')[0] || 'unknown';

  return { device, os, browser, language, locale };
};


